import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('user', '/users')
const actions = generator.generate()

export default actions
